<template>
  <div class="middle-page-network-error__root">
    <div class="icon"></div>
    <div class="label">网络不给力，请刷新重试</div>
    <base-button type="primary" class="btn-refresh" @click="onRefreshClick">刷新</base-button>
  </div>
</template>

<script setup lang="ts">
import BaseButton from '@/components/base-button.vue';
import { useRoute, useRouter } from 'vue-router';
import { isUrlAllowed } from '@/utils/check-url-allow';

const route = useRoute();
const router = useRouter();

const onRefreshClick = () => {
  // url query 传递刷新后的目标页
  const { cb } = route.query;
  if (cb) {
    const cbString = cb.toString();
    if (isUrlAllowed(cbString)) {
      location.replace(cbString);
      return;
    }
  }

  // query为空 返回首页
  router.replace('/');
};
</script>

<style lang="scss" scoped>
.middle-page-network-error {
  &__root {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .icon {
      display: inline-block;
      background-image: url('@/assets/svg/white/icon-network-error.svg');
      width: 100px;
      height: 100px;
    }

    .label {
      margin-top: 12px;
      height: 22px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: var(--lowcode-text-02);
      line-height: 22px;
    }

    .btn-refresh {
      margin-top: 16px;
    }
  }
}
</style>
